module.exports = __webpack_public_path__ + "img/login-v2-dark.8b6e22b1.svg";